import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';  // Note: no file extension
import reportWebVitals from './reportWebVitals';
import './styles/tailwind.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

reportWebVitals();